import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

// eslint-disable-next-line react/prop-types
const GTM = ({ gtmId }) => {
  useEffect(() => {
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
    document.head.appendChild(script);

    const dataLayerScript = document.createElement("script");
    dataLayerScript.innerHTML = `
      (function(w,d,s,l,i){
        w[l]=w[l]||[];
        w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
        var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
        j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
        f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${gtmId}');
    `;
    document.head.appendChild(dataLayerScript);

    return () => {
      document.head.removeChild(script);
      document.head.removeChild(dataLayerScript);
    };
  }, [gtmId]);

  return <Helmet></Helmet>;
};

export default GTM;
